import { render } from "./ModeloVisualizacao.vue?vue&type=template&id=8c3486d2&scoped=true&ts=true"
import script from "./ModeloVisualizacao.vue?vue&type=script&lang=ts"
export * from "./ModeloVisualizacao.vue?vue&type=script&lang=ts"

import "./ModeloVisualizacao.vue?vue&type=style&index=0&id=8c3486d2&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c3486d2"]])

export default __exports__